import { render, staticRenderFns } from "./AdminPostcodesView.vue?vue&type=template&id=80d330de"
import script from "./AdminPostcodesView.vue?vue&type=script&lang=js"
export * from "./AdminPostcodesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports